import { render, staticRenderFns } from "./PrintBillBearK80.vue?vue&type=template&id=31ac0208&scoped=true"
import script from "./PrintBillBearK80.vue?vue&type=script&lang=js"
export * from "./PrintBillBearK80.vue?vue&type=script&lang=js"
import style0 from "./PrintBillBearK80.vue?vue&type=style&index=0&id=31ac0208&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ac0208",
  null
  
)

export default component.exports